











import Vue from "vue";
import CrusadeForce from "@/model/CrusadeForce";
import { ZealotCollections } from "@/services/MongoService";
import SearchTable from "@/components/common/SearchTable.vue";
import CrusadeCard from "@/model/CrusadeCard";
import {
  CrusadeCardTableHeaders,
  CrusadeCardFormFields,
} from "@/meta/CrusadeCardModel";
import BattlescribeImportService from "@/services/BattlescribeImportService";

export default Vue.extend({
  name: "ForceDetail",
  props: ["id"],
  components: { SearchTable },
  data: () => {
    return {
      loading: false,
      force: {} as CrusadeForce,
      cardHeaders: CrusadeCardTableHeaders,
      cardFormFields: CrusadeCardFormFields,
      importFiles: null,
    };
  },
  mounted() {
    this.loadForce();
  },
  computed: {
    orderOfBattle(): CrusadeCard[] {
      return this.force?.orderOfBattle || [];
    },
  },
  methods: {
    async loadForce() {
      this.loading = true;
      this.force = await this.$mongoService.findDocument(
        ZealotCollections.FORCES,
        this.id
      );
      this.loading = false;
    },
    async saveForce() {
      this.loading = true;
      this.force = await this.$mongoService.updateDocument(
        ZealotCollections.FORCES,
        this.force._id,
        this.force
      );
      this.loading = false;
    },
    async saveCard({ item, index }: { item: CrusadeCard; index: number }) {
      if (!this.force) {
        return;
      }
      if (!this.force.orderOfBattle) {
        this.force.orderOfBattle = [];
      }
      if (index > -1) {
        this.force.orderOfBattle[index] = item;
      } else {
        this.force.orderOfBattle.push(item);
      }
      await this.saveForce();
    },
    async deleteCard({ index }: { item: CrusadeCard; index: number }) {
      if (
        !this.force ||
        !this.force.orderOfBattle ||
        index < 0 ||
        index >= this.force.orderOfBattle.length
      ) {
        return;
      }
      this.force.orderOfBattle.splice(index, 1);

      await this.saveForce();
    },
    async rosterImport(file: File) {
      if (!this.force || !file) {
        return;
      }
      this.loading = true;
      const service = new BattlescribeImportService();
      const cards = await service.extractCrusadeCards(await file.arrayBuffer());
      this.importFiles = null;
      this.force.orderOfBattle = [...cards];

      await this.saveForce();
    },
  },
});
